import React from 'react';
import SyncUsersContainer from './SyncUsersContainer';

class SyncUsersScreen extends React.Component {

    public render() {
        return <SyncUsersContainer />
    }

}

export default SyncUsersScreen;